import type { CubeResultMapper } from '@/types/filter';
import { toStringOrNull } from '@/utils/cube/mapper';

const mapDimensionToOption =
  (dimension: string, getLabel?: (value: string) => string): CubeResultMapper =>
  cubeRow => {
    const value = toStringOrNull(cubeRow[dimension]);
    if (value === null) return null;

    return { value, label: getLabel ? getLabel(value) : value };
  };

export default mapDimensionToOption;
